<template>
  <v-navigation-drawer
    :value="showDrawer"
    temporary
    fixed
    right
    width="500"
    :disable-route-watcher="true"
    stateless
    :color="isNuovoArticolo ? '#eafdeb' : ''"
  >
    <template v-slot:prepend>
      <v-list-item two-line>
        <v-list-item-content>
          <v-list-item-title ref="titolo" class="text-h6">{{
            drawerTitle
          }}</v-list-item-title>
          <v-list-item-subtitle>{{ drawerSubtitle }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </template>
    <v-divider></v-divider>
    <dialog-errore
      :show="dialogErrore"
      title="Errore aggiornamento Prodotto"
      :message="erroreMessage"
      @dialogConfirm="dialogErrore = false"
    />
    <v-form ref="form" v-model="formFieldsValid" lazy-validation>
      <v-list dense>
        <v-list-item
          v-for="item in prodottoItems(updateTrigger)"
          :key="item.label"
        >
          <v-list-item-content>
            <v-list-item-title>
              <component
                :is="'p' + item.type"
                :item="item"
                @change="componentValueChange"
                :appoggio="locProdotto"
                :disabled="readOnly"
                :updateTrigger="updateTrigger"
                :defaultUsed="locProdotto.defaultUsed"
              />
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-form>
    <template v-slot:append>
      <v-container fluid>
        <v-row align="center">
          <v-col
            class="d-flex justify-space-around"
            cols="12"
            sm="6"
            v-if="!readOnly"
          >
            <v-btn
              color="success mb-2"
              @click="onSalva"
              :disabled="!formFieldsValid"
              >Salva</v-btn
            >
          </v-col>
          <v-col class="d-flex justify-space-around" cols="12" sm="6">
            <v-btn color="secondary mb-s" @click="onAnnulla">{{
              annullaTitle
            }}</v-btn>
          </v-col>
        </v-row>
      </v-container>
    </template>
  </v-navigation-drawer>
</template>

<script>
/* eslint-disable */
import * as dot from "dot-object";
import _ from "lodash";
import errorService from "@/services/errorService";
import DialogErrore from "@/components/dialogErrore";
import configurazioni from "@/services/configurazioniService.js";
import magazzino from "@/services/magazzinoService.js";
import prodotti from "@/services/prodottiService.js";
import pTesto from "@/views/drawer/elementi/testo";
import pCodice from "./elementi/codice";
import pGiacenza from "@/views/drawer/elementi/giacenza";
import pMultiselect from "@/views/drawer/elementi/multiselect";
import pMultiselectTag from "@/views/drawer/elementi/multiselectTag";
import pBarcode from "./elementi/barcode";
import pSwitch from "@/views/drawer/elementi/switch";
import pDistintaBase from "@/views/drawer/elementi/distintaBase";
import pEmettitori from "./elementi/emettitori";
import pCalcolato from "@/views/drawer/elementi/calcolato";

export default {
  components: {
    DialogErrore,
    pTesto,
    pCodice,
    pMultiselect,
    pMultiselectTag,
    pBarcode,
    pSwitch,
    pGiacenza,
    pDistintaBase,
    pEmettitori,
    pCalcolato,
  },
  data: () => ({
    backoffice: null,
    show: false,
    locProdotto: null,
    formFieldsValid: true,
    dialogErrore: false,
    erroreMessage: "",
    updateTrigger: 1,
    rettificaGiacenza: null,
    marchi: [],
    impostazioni: null,
    elencoVariazioni: [],
    elencoPreparazioni: [],
    // usaTagliaColore: false
  }),
  async mounted() {
    this.backoffice = await configurazioni.getConfigurazione(
      "backoffice",
      "pagine"
    );
    this.impostazioni = await configurazioni.getConfigurazione(
      "backoffice",
      "impostazioni"
    );
    this.locProdotto = this.$store.getters["prodotti/prodotto"] || null;
    // TODO: Correggere Gestione. Nel prodotto deve essere salvato il marchio con codice e descrizione
    // Per adesso è salvata solo la descrizione e non funziona il caricamento automatico nel drawer
    // 2 soluzioni:
    // 1) Si mette codice = Descrizione (es tipoItem e tipoBene funzionano così)
    // 2) Si modifica la gestione riportando sia codice che descrizione, ma va gestita in tutti i punti dove viene utilizzato il marchio
    this.marchi = await configurazioni.getConfigurazione(
      "prodotti_categorie",
      "marchi"
    );

    this.setInfoTipo();
    this.setInfoDetraibile();
    this.setInfoLotto();
    this.setInfoBom();
    /*     const tc = await configurazioni.getConfigurazione('display_generale', 'ricerca')
    this.usaTagliaColore = tc.prodotto.cercaTagliaColore */
  },
  watch: {
    async prodotto(value) {
      this.locProdotto = null;
      await this.$nextTick();
      this.updateTrigger++;
      this.locProdotto = value;
      this.setInfoTipo();
      this.setInfoDetraibile();
      this.setInfoLotto();
      this.setInfoBom();
    },
  },
  computed: {
    showDrawer() {
      return this.$store.getters.rightDrawer;
    },
    readOnly() {
      return this.$store.getters.rightDrawerReadOnly;
    },
    drawerTitle() {
      if (this.readOnly) {
        return "Visualizza prodotto";
      } else {
        return this.locProdotto && this.locProdotto._id
          ? "Modifica prodotto"
          : "Nuovo prodotto";
      }
    },
    drawerSubtitle() {
      return this.locProdotto
        ? `${this.locProdotto.codice} ${this.locProdotto.descrizione}`
        : "";
    },
    annullaTitle() {
      return this.readOnly ? "Chiudi" : "Annulla";
    },
    prodotto() {
      return this.$store.getters["prodotti/prodotto"] || null; // || { codice: '', descrizione: '' }
    },
    prodottoItems_old() {
      if (!this.locProdotto || !this.backoffice) {
        return [];
      }
      const vars = this.backoffice.articoli;
      const items = [];
      // item.subModel, --> usato per marchio, tipoItem tipoBene : Da categorie leggo codice, descrizione ma devo salvare solo descrizione o solo codice
      for (const item of vars) {
        let hideIf = item.hideIf;
        let showIf = item.showIf;
        if (hideIf) {
          hideIf = hideIf.replace("appoggio.", "");
          const test = _.get(this.locProdotto, hideIf, false);
          if (test) continue;
        }
        if (showIf) {
          showIf = showIf.replace("appoggio.", "");
          const test = _.get(this.locProdotto, showIf, false);
          if (!test) continue;
        }
        let valore = dot.pick(item.valueField, this.locProdotto);

        // ************************************************************************
        // TODO: Sistemare. E' un workaround per far funzionare i Marchi
        if (item.model === "marchio") {
          const m = this.marchi.find((x) => x.descrizione === valore);
          if (m) {
            valore = m.codice;
          }
        }
        // *************************************************************************
        items.push({ value: valore, ...item });
      }
      return items;
    },
    isNuovoArticolo() {
      return this.$store.getters["movimenti/creaArticolo"];
    },
    magazziniMultipli() {
      return this.$store.getters["magazzini/magazziniMultipli"];
    },
    magazzinoSelezionato() {
      return this.$store.getters["magazzini/codiceMagazzino"];
    },
    calcolaGiacenza() {
      let giacenza = this.locProdotto.magazzino.giacenza || 0;
      if (this.magazziniMultipli) {
        const giacenzaParziale = _.get(
          this.locProdotto,
          "magazzino.giacenzaParziale",
          null
        );
        if (
          typeof giacenzaParziale === "object" &&
          !_.isEmpty(giacenzaParziale)
        ) {
          const gg = giacenzaParziale[this.magazzinoSelezionato] || {};
          giacenza = gg.giacenza || 0;
        }
      }
      return +parseFloat(giacenza).toFixed(2);
      /*       const giacenza = this.locProdotto.magazzino.giacenza || 0
      if (!this.magazziniMultipli) {
        return giacenza
      } else {
        const giacenzaParziale = _.get(this.locProdotto, 'magazzino.giacenzaParziale', null)
        if (typeof giacenzaParziale === 'object' && !_.isEmpty(giacenzaParziale)) {
          const gg = giacenzaParziale[this.magazzinoSelezionato] || {}
          return gg.giacenza || 0
        } else {
          return giacenza 
        }
      } */
    },
  },
  methods: {
    prodottoItems() {
      if (!this.locProdotto || !this.backoffice) {
        return [];
      }
      const vars = this.backoffice.articoli;
      const items = [];
      // item.subModel, --> usato per marchio, tipoItem tipoBene : Da categorie leggo codice, descrizione ma devo salvare solo descrizione o solo codice
      for (const item of vars) {
        let hideIf = item.hideIf;
        let showIf = item.showIf;
        if (hideIf) {
          hideIf = hideIf.replace("appoggio.", "");
          const test = _.get(this.locProdotto, hideIf, false);
          if (test) continue;
        }
        if (showIf) {
          showIf = showIf.replace("appoggio.", "");
          const test = _.get(this.locProdotto, showIf, false);
          if (!test) continue;
        }
        let valore = dot.pick(item.valueField, this.locProdotto);

        // ************************************************************************
        // TODO: Sistemare. E' un workaround per far funzionare i Marchi
        if (item.model === "marchio") {
          const m = this.marchi.find((x) => x.descrizione === valore);
          if (m) {
            valore = m.codice;
          }
        }
        // *************************************************************************
        items.push({ value: valore, ...item });
      }
      return items;
    },
    setInfoTipo() {
      if (this.locProdotto) {
        this.locProdotto.isArticolo = this.locProdotto.tipoItem === "PRODOTTO";
        this.locProdotto.isReparto = this.locProdotto.tipoItem === "REPARTO";
        this.locProdotto.isServizio = this.locProdotto.tipoBene === "SERVIZIO";
        this.locProdotto.isProdotto = this.locProdotto.tipoBene === "PRODOTTO";
      }
    },
    setInfoDetraibile() {
      if (this.locProdotto) {
        this.locProdotto.isDetraibile =
          this.locProdotto &&
          this.locProdotto.datiFiscali &&
          this.locProdotto.datiFiscali.ssnn &&
          this.locProdotto.datiFiscali.ssnn.detraibile; // _.get(this.locProdotto, 'ssnn.detraibile', false)
        this.locProdotto.isNotDetraibile = !this.locProdotto.isDetraibile;
      }
    },
    setInfoLotto() {
      if (this.locProdotto) {
        this.locProdotto.isLotto =
          this.locProdotto &&
          this.locProdotto.lotti &&
          this.locProdotto.lotti.gestione &&
          this.locProdotto.lotti.gestione.abilita;
        this.locProdotto.isNotLotto = !this.locProdotto.isLotto;
      }
      this.updateTrigger++;
    },
    setInfoBom() {
      if (this.locProdotto) {
        this.locProdotto.isBom =
          this.locProdotto &&
          this.locProdotto.bom &&
          this.locProdotto.bom.gestione &&
          this.locProdotto.bom.gestione.abilita;
        this.locProdotto.isNotBom = !this.locProdotto.isBom;
      }
      this.updateTrigger++;
    },
    async componentValueChange(data) {
      let { model, subModel, value, decimals, defaultUsed } = data;

      // Nel caso di modifica di taglia e colore verifico che il valore precedente sia vuoto, altrimenti errore modifica TC
      // Inserito lockIf su multiselect --> lockIf="appoggio_id"

      /*       if (['varianti.variante1', 'varianti.variante2'].includes(model)) {
        const p = this.locProdotto
        if (p._id && _.get(this.locProdotto, 'varianti.variante1.codice', '') && _.get(this.locProdotto, 'varianti.variante2.codice', '')) {
          // Nel caso di modifica di taglia e colore verifico che il valore precedente sia vuoto, altrimenti errore modifica TC
          
          var orig = model === 'varianti.variante1' ? _.get(this.locProdotto, 'varianti.variante1', '') :  _.get(this.locProdotto, 'varianti.variante2', '')
          if (value.codice !== orig.codice) {
            this.erroreMessage = 'Non è possibile modificare taglia o colore per un prodotto già inserito! Se necessario creare un nuovo prodotto e cancellare quello non usato.'
            value = orig
            this.dialogErrore = true
            this.updateTrigger++            
          }
          return
        }
      } */
      let tgt = {};
      if (subModel) {
        let vv = value[subModel];
        if (decimals >= 0) {
          vv = +parseFloat(vv).toFixed(decimals);
        }
        dot.str(model, vv, tgt);
      } else {
        let vv = value;
        if (decimals >= 0) {
          vv = +parseFloat(vv).toFixed(decimals);
        }
        dot.str(model, vv, tgt);
      }
      if (model !== "magazzino.giacenza") {
        // console.log('aggiornato')
        _.merge(this.locProdotto, tgt);
      }
      if (defaultUsed) {
        _.set(this.locProdotto, "appoggio.defaultUsed", true);
      }
      await this.aggiornaCorrelati(data);
    },
    async aggiornaCorrelati(data) {
      // TODO: inserire Barcode, inserire iva
      switch (data.model) {
        case "codice":
          this.locProdotto.codice = data.value.toLowerCase();
          break;
        case "datiFiscali.reparto": // TODO: Sistemare. Verificare come passare CodiceStampante oppure togliere campi in più sugli altri elenenti. Vedi mounted su multiselect
          let reparto = {
            codice: this.locProdotto.datiFiscali.reparto.codice,
            descrizione: this.locProdotto.datiFiscali.reparto.descrizione,
            stampante: this.locProdotto.datiFiscali.reparto.stampante.numero,
          };
          this.locProdotto.datiFiscali = {};
          this.locProdotto.datiFiscali.reparto = reparto;
          try {
            const cnfReparti = await configurazioni.getConfigurazione(
              "prodotti_reparti_fiscali",
              "reparti"
            );
            const rf = cnfReparti.find(
              (x) => x.codice === this.locProdotto.datiFiscali.reparto.codice
            );

            const cnfIva = await configurazioni.getConfigurazione(
              "prodotti_aliquote_iva",
              "aliquote"
            );
            const ai = cnfIva.find((x) => x.codice === rf.codiceIva);
            let aliquotaIva = {
              codice: ai.codice,
              valore: ai.aliquota,
              descrizione: ai.descrizione,
              tipoApplicazione: "banco", // TODO: andrà inserita la possibilità di scegliere più tipi iva in base al tipoApplicazione. Forse nel reparto
            };
            this.locProdotto.datiFiscali.aliquoteIva = [];
            this.locProdotto.datiFiscali.aliquoteIva.push(aliquotaIva);
          } catch (error) {
            console.log("errore aggiornamento reparto fiscale:", error);
          }
          break;
        case "ricercaBarcode":
          const adesso = new Date();
          const code = this.locProdotto.ricercaBarcode;
          let newBarcode = {
            codice: code,
            da: adesso,
            attivo: true,
          };
          if (
            !this.locProdotto.barcode ||
            this.locProdotto.barcode.length === 0
          ) {
            this.locProdotto.barcode = [];
          }
          //} else {
          if (!this.locProdotto.barcode.find((x) => x.codice === code)) {
            for (let el of this.locProdotto.barcode.filter(
              (x) => x.codice !== code
            )) {
              if (el.attivo) {
                el.attivo = false;
                el.a = adesso;
              }
            }
            //}
            this.$set(
              this.locProdotto.barcode,
              this.locProdotto.barcode.length || 0,
              newBarcode
            );
          }
          break;
        case "prezzo.L6.base":
          let valore = isNaN(data.value) ? 0 : parseFloat(data.value);
          this.locProdotto.prezzo.L6.base = +valore.toFixed(2);
          break;
        case "prezzo.L5.base":
          valore = isNaN(data.value) ? 0 : parseFloat(data.value);
          this.locProdotto.prezzo.L5.base = +valore.toFixed(2);
          break;
        case "prezzo.L4.base":
          valore = isNaN(data.value) ? 0 : parseFloat(data.value);
          this.locProdotto.prezzo.L4.base = +valore.toFixed(2);
          break;
        case "prezzo.L3.base":
          valore = isNaN(data.value) ? 0 : parseFloat(data.value);
          this.locProdotto.prezzo.L3.base = +valore.toFixed(2);
          break;
        case "prezzo.L2.base":
          valore = isNaN(data.value) ? 0 : parseFloat(data.value);
          this.locProdotto.prezzo.L2.base = +valore.toFixed(2);
          break;
        case "prezzo.L1.base":
          valore = isNaN(data.value) ? 0 : parseFloat(data.value);
          this.locProdotto.prezzo.L1.base = +valore.toFixed(2);
          break;
        case "magazzino.prezzoAcquisto":
          valore = isNaN(data.value) ? 0 : parseFloat(data.value);
          this.locProdotto.magazzino.prezzoAcquisto = +valore.toFixed(2);
          this.locProdotto.magazzino.valore = +(
            this.locProdotto.magazzino.giacenza *
            this.locProdotto.magazzino.prezzoAcquisto
          ).toFixed(2);
          break;
        case "magazzino.giacenza":
          valore = isNaN(data.value) ? 0 : +parseFloat(data.value).toFixed(2);
          const giac = this.calcolaGiacenza;
          const delta = +(valore - giac).toFixed(2);
          let rettifica = {
            idProdotto: this.locProdotto._id,
            delta: delta,
            valore: valore,
            tipoMovimento: "rettifica",
            magazzino: this.$store.getters["magazzini/codiceMagazzino"],
          };
          this.rettificaGiacenza = rettifica;
          this.locProdotto.magazzino.giacenzaParziale =
            this.locProdotto.magazzino.giacenzaParziale || {};
          let mg = this.locProdotto.magazzino.giacenzaParziale;
          // mg[rettifica.magazzino].giacenza = +((mg[rettifica.magazzino].giacenza || 0) + valore).toFixed(2)
          mg[rettifica.magazzino] = mg[rettifica.magazzino] || {};
          mg[rettifica.magazzino].giacenza = +valore.toFixed(2);
          mg[rettifica.magazzino].valore = +(
            mg[rettifica.magazzino].giacenza *
            (this.locProdotto.magazzino.prezzoAcquisto || 0)
          ).toFixed(2);
          let totG = 0;
          let totV = 0;
          for (let gg of Object.keys(mg)) {
            totG += mg[gg].giacenza;
            totV += mg[gg].valore;
            // totV += +(mg[gg].giacenza * this.locProdotto.magazzino.prezzoAcquisto).toFixed(2)
          }
          this.locProdotto.magazzino.giacenza = +totG.toFixed(2);
          this.locProdotto.magazzino.valore = +totV.toFixed(2);
          break;
        case "tipoItem":
          this.setInfoTipo();
          break;
        case "datiFiscali.ssnn.detraibile":
          this.setInfoDetraibile();
          if (this.locProdotto.isNotDetraibile) {
            delete this.locProdotto.datiFiscali.ssnn;
          } else {
            this.locProdotto.datiFiscali.ssnn.codiceDetrazione = "AD";
            this.locProdotto.datiFiscali.ssnn.detraibilitaPercentuale = 100;
          }
          break;
        case "lotti.gestione.abilita":
          this.setInfoLotto();
          break;
        case "bom.gestione.abilita":
          this.setInfoBom();
          break;
        case "lotti.gestione.tipoLottoCarico":
        case "lotti.gestione.tipoLottoScarico":
        case "lotti.gestione.criterioConsumoCarico":
        case "lotti.gestione.criterioConsumoScarico":
        case "marchio":
          this.updateTrigger++;
          break;
        case "tipoBene":
          this.updateTrigger++;
          break;
        case "tag":
          this.locProdotto.tag = data.value;
          break;
        default:
          break;
      }
      this.updateTrigger++;
    },
    onAnnulla() {
      this.$refs.form.reset();
      if (this.isNuovoArticolo) {
        // Drawer articoli richiamato da prodotti
        this.$store.commit("movimenti/CLEAR_CREA_ARTICOLO");
      } else {
        this.$store.commit("SET_RIGHT_DRAWER", false);
        this.$store.commit("prodotti/SET_REFRESH");
      }
    },
    async onSalva() {
      let valid = this.$refs.form.validate();
      errorService.onInfo(JSON.stringify(this.locProdotto));
      const id = this.locProdotto._id;
      let nuovoCodice = "";
      // Se _id === undefined --> sto aggiungendo un prodotto --> verifico se già presente nel db
      if (!id) {
        const codice = this.locProdotto.codice;
        const taglia = _.get(this.locProdotto, "varianti.variante1.codice", "");
        const colore = _.get(this.locProdotto, "varianti.variante2.codice", "");
        nuovoCodice = this.creaCampoRicercaTC_Codici(codice, taglia, colore);
        let esistente = await prodotti.getProdotto(nuovoCodice);
        if (esistente) {
          valid = false;
          this.erroreMessage =
            "Il prodotto che si sta cercando di aggiungere è già presente nell'archivio!";
          this.dialogErrore = true;
        } else {
          this.erroreMessage = "";
        }
      }
      if (valid) {
        var prodottoCreato;
        if (this.impostazioni.usaVariazioni) {
          this.locProdotto.presenzaVariazioni = await this.verificaPresenzaVariazioni(
            this.locProdotto
          );
        }
        if (_.get(this.locProdotto, "appoggio.defaultUsed")) {
          this.locProdotto.defaultUsed = true;
          delete this.locProdotto.appoggio;
        }
        if (this.isNuovoArticolo) {
          prodottoCreato = await this.salvaSuDB();
        } else {
          this.$store.commit("prodotti/SET_PRODOTTO", this.locProdotto);
          this.$store.commit("prodotti/SET_PRODOTTO_SAVED");
        }
        await prodotti.clearCache();
        this.$store.commit("prodotti/SET_REFRESH");

        if (this.rettificaGiacenza) {
          if (!this.rettificaGiacenza.idProdotto) {
            const newPr = this.locProdotto;
            this.rettificaGiacenza.idProdotto =
              _.get(newPr, "_id") ||
              _.get(prodottoCreato, "_id") ||
              nuovoCodice;
          }
          await magazzino.creaMovimentoRettificaGiacenza(
            this.rettificaGiacenza
          );
          this.rettificaGiacenza = null;
        }
      }
    },
    creaCampoRicercaTC_Codici(codice, taglia, colore) {
      var pattern = /[^a-zA-Z0-9-]+/gi;
      var campo = String(codice) + String(taglia) + String(colore);
      return campo.replace(pattern, "_").toLowerCase();
    },
    async salvaSuDB() {
      const id = this.locProdotto._id;
      let prodotto = null;
      if (id) {
        prodotto = await prodotti.aggiornaProdotto(this.locProdotto);
        if (!prodotto) {
          this.dialogErrore = true;
          return;
        }
      } else {
        prodotto = await prodotti.creaProdotto(this.locProdotto);
        if (!prodotto) {
          this.dialogErrore = true;
          return;
        }
        this.$store.commit("movimenti/CLEAR_CREA_ARTICOLO");
        this.$store.commit("movimenti/SET_ARTICOLO_CREATO", prodotto);
      }
      await this.$nextTick();
      this.locProdotto = null;
      return prodotto;
    },
    async verificaPresenzaVariazioni(prodotto) {
      if (this.elencoVariazioni.length === 0) {
        const menu = await configurazioni.getConfigurazione("menu");
        this.elencoVariazioni = menu.variazioni;
        this.elencoPreparazioni = menu.preparazioni;
      }
      const categorie = prodotto.statistici;
      let elenco = categorie
        ? Object.values(categorie).map((x) => x.codice)
        : [];
      elenco.push(prodotto.datiFiscali.reparto.codice);

      let variazioniDisponibili = [];
      let preparazioniDisponibili = [];
      variazioniDisponibili = variazioniDisponibili.concat(
        prodotto.variazioni || []
      );
      preparazioniDisponibili = preparazioniDisponibili.concat(
        prodotto.preparazioni || []
      );

      let variazioniPerCategoria = this.elencoVariazioni.filter(
        (x) => _.intersection(elenco, x.elencoCategorie).length > 0
      );
      let vv = variazioniPerCategoria.map((x) => x.variazioni);
      vv = _.flatten(vv);
      variazioniDisponibili = _.unionBy(variazioniDisponibili, vv, "codice");

      let preparazioniPerCategoria = this.elencoPreparazioni.filter(
        (x) => _.intersection(elenco, x.elencoCategorie).length > 0
      );
      let pp = preparazioniPerCategoria.map((x) => x.preparazioni);
      pp = _.flatten(pp);
      preparazioniDisponibili = _.unionBy(
        preparazioniDisponibili,
        pp,
        "codice"
      );

      return (
        variazioniDisponibili.length > 0 || preparazioniDisponibili.length > 0
      );
    },
  },
};
</script>
